import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { VmeCommonModule } from '../../vme-common.module';
import { VMEComponentsModule } from '../../vme-components.module';
import { VmeDirectivesModule } from '../../vme-directives.module';
import { VmePipesModule } from '../../vme-pipes.module';
import { EmailTemplatesComponent } from './email-templates.component';
import { QuillModule } from 'ngx-quill';

const routes: Routes = [
  { path: '', component: EmailTemplatesComponent, data: { title: 'Email Templates' } },
];

@NgModule({
  imports: [RouterModule.forChild(routes), QuillModule],
  exports: [RouterModule],
})
export class EmailTemplatesRoutingModule {}

@NgModule({
  imports: [
    EmailTemplatesRoutingModule,
    VmeCommonModule,
    VmeDirectivesModule,
    VmePipesModule,
    VMEComponentsModule,
  ],
  declarations: [EmailTemplatesComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class EmailTemplatesModule {}
